import { useState } from 'react'

// components
import AccordionIconComponent from 'components/icons/AccordionIconComponent'

// styles
import styles from './AccordionBlock.module.scss'

type Props = {
  title: string
  children: React.ReactNode
}

export default function AccordionBlock({ title, children }: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <dl className={styles.block}>
      <dt
        className={styles.blockTitle}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        <span className={styles.blockTitleText}>{title}</span>
        <span className={styles.blockTitleIcon}>
          <AccordionIconComponent isOpenAccordion={isOpen} accordionStyle={styles.accordionIcon} />
        </span>
      </dt>
      <dd className={`${styles.blockContent} ${isOpen ? styles.blockContentActive : ''}`}>
        {children}
      </dd>
    </dl>
  )
}
